import { UseQuerySubscription } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import StructureAPI from '../StructureAPI';

type Options = Parameters<UseQuerySubscription<any>>[1];
function useStructuresWorkspace(workspaceId?: string, options?: Options) {
  return StructureAPI.endpoints.getStructureV2.useQuery(workspaceId, options);
}

export default useStructuresWorkspace;
